import { Types } from "../actions/roleGroupActions";

const initialState = {
    RoleGroupDetailbyID: {},
    RoleFunctionList: [],
    RoleMenuList: [],
    RoleEditRelation: {},
    RoleGroupList: {},
    roleGrouploading: false,
    isTaskUpdatedRoleGroup: false,
};

export const roleGroupReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_ROLE_GROUP_BY_ID:
            return {
                ...state,
                RoleGroupDetailbyID: action.payload,
                roleGrouploading: false,
            };

        case Types.SET_ROLE_FUNCTION_LIST:
            return {
                ...state,
                RoleFunctionList: action.payload,
                roleGrouploading: false,
            };

        case Types.SET_ROLE_MENU_LIST:
            return {
                ...state,
                RoleMenuList: action.payload,
                roleGrouploading: false,
            };
        case Types.SET_ROLE_GROUP_LIST:
            return {
                ...state,
                RoleGroupList: action.payload,
                roleGrouploading: false,
            };

        case Types.SET_EDIT_RELATION:
            return {
                ...state,
                RoleEditRelation: action.payload,
                RoleMenuList: [],
                RoleFunctionList: [],
                roleGrouploading: false,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedRoleGroup: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdatedRoleGroup: false,
            };
        default:
            return state;
    }
};
